
import { MDCRipple } from '@material/ripple';
import { Vue, Prop } from 'vue-property-decorator';

export default class MaterialListItem extends Vue {

    @Prop(String) readonly text!: String;
    @Prop(String) readonly secondary?: String;

    private ctrl?: MDCRipple;

    mounted() {
        this.ctrl = MDCRipple.attachTo(this.$el);
    }

    updated() {
        this.ctrl?.destroy();
        this.ctrl = MDCRipple.attachTo(this.$el);
    }

    unmounted() {
        this.ctrl?.destroy();
    }
}
